import type { ConsumerInsightsState, StateTree } from '@makemydeal/dr-dash-types';

export const getConsumerInsights = (state: StateTree): ConsumerInsightsState => {
    return state.consumerInsights ?? {};
};
